export const VERSUS_TEXT = "project.preview.header.text.versus";
